import { message } from "antd";
import { useMutation } from "@tanstack/react-query";

import sdk, { GraphQLError } from "@/sdk";

export function useExportSecuritiesCustomers() {
  return useMutation({
    mutationFn: () => sdk.exportSecuritiesCustomersExcel(),
    onSuccess: ({ exportSecuritiesCustomersExcel: { reportUrl } }) => {
      window.open(reportUrl.startsWith("http") ? reportUrl : `/${reportUrl}`);
      message.success("Excel файл амжилттай үүслээ");
    },
    onError: (err) => {
      message.error(
        (err as GraphQLError).response?.errors?.[0]?.message ?? "Алдаа гарлаа",
      );
    },
  });
}
